import styles from "./GetPremiumModal.module.scss";
import close from "../../../assets/icons/close.svg";
import done from "../../../assets/icons/done.svg";
import cancel from "../../../assets/icons/close-red.svg";
import select from "../../../assets/icons/select.svg";
import Button from "../../button/Button";
import Select, { components } from "react-select";
import arrow from "../../../assets/icons/arrow-down.svg";
import { useState } from "react";

interface GetPremiumModalProps {
  setIsModalUpdateVisible: (arg: boolean) => void;
  setIsModalOrderVisible: (arg: boolean) => void;
}

const options = [
  { value: "89.99", label: "1 PC" },
  { value: "99.99", label: "2 PC" },
  { value: "109.99", label: "3 PC" },
];

const customStyles = {
  control: (provided: any) => ({
    ...provided,
    border: "none",
    height: "42px",
    paddingLeft: "10px",
    "&:outline": {
      border: "none",
    },

    "&:placeholder": {
      display: "none",
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    border: "none",
  }),
};

const GetPremiumModal: React.FC<GetPremiumModalProps> = ({
  setIsModalUpdateVisible,
  setIsModalOrderVisible,
}) => {
  const [selectedOption, setSelectedOption] = useState<any>(options[0]);

  const DropdownIndicator = (props: any) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={arrow} alt="arrow" style={{ padding: "0 6px 0 2px" }} />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>
          Get the Premium package to unlock Fortect’s full capabilities
        </p>
        <img
          className={styles.root_header_img}
          src={close}
          alt="close"
          onClick={() => setIsModalUpdateVisible(false)}
        />
      </div>
      <p className={styles.root_subtitle}>
        Choose the Best Option for Your Needs
      </p>
      <div className={styles.root_table}>
        <div className={styles.root_table_left}>
          <div className={styles.root_table_left_item}>
            Removes & Detects viruses in real
          </div>
          <div className={styles.root_table_left_item}>
            Repair Windows Damage
          </div>
          <div className={styles.root_table_left_item}>
            Operating System Restoration
          </div>
          <div className={styles.root_table_left_item}>
            PC Scan and Assessment
          </div>
          <div className={styles.root_table_left_item}>
            Optimize Windows Registry
          </div>
          <div className={styles.root_table_left_item}>
            Unlimited use for 1 year
          </div>
          <div className={styles.root_table_left_item}>
            24/7 support for 1 year
          </div>
          <div className={styles.root_table_left_item}>
            Multi-device protection and repair
          </div>
        </div>
        <div className={styles.root_table_center}>
          <div className={styles.root_table_center_header}>Basic Version</div>
          <div className={styles.root_table_center_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
          <div className={styles.root_table_center_item}>
            <img src={cancel} alt="cancel" height={20} width={20} />
          </div>
        </div>
        <div className={styles.root_table_right}>
          <div className={styles.root_table_right_header}>Premium Package</div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_item}>
            <img src={done} alt="done" height={20} width={20} />
          </div>
          <div className={styles.root_table_right_footer}>
            <p className={styles.root_table_right_footer_title}>
              Number of Devices
            </p>
            <Select
              defaultValue={selectedOption}
              styles={customStyles}
              onChange={setSelectedOption}
              options={options}
              className={styles.root_select}
              placeholder="1 PC"
              components={{
                DropdownIndicator,
              }}
            />
            <div className={styles.root_table_right_footer_price}>
              <p>${selectedOption.value ? selectedOption.value : 88.99}</p>
              <p className={styles.root_table_right_footer_price_old}>
                $
                {selectedOption.value
                  ? `${Number(selectedOption.value) + 10}`
                  : 99.99}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.root_buttons}>
        <Button
          onClick={() => setIsModalUpdateVisible(false)}
          type="default"
          text={"Cancel"}
          classNames={styles.root_buttons_cancel}
        />
        <Button
          onClick={() => {
            setIsModalUpdateVisible(false);
            setIsModalOrderVisible(true);
          }}
          type="expired"
          text={"Upgrade Now"}
          classNames={styles.root_buttons_update}
        />
      </div>
      <div className={styles.root_tableMobile}>
        <div className={styles.root_tableMobile_header}>
          <p className={styles.root_tableMobile_title}>Premium Package</p>
          <p className={styles.root_tableMobile_subtitle}>Number of Devices</p>
          <img src={select} alt="select" />
          <div className={styles.root_tableMobile_price}>
            <p>${selectedOption.value ? selectedOption.value : 88.99}</p>
            <p className={styles.root_tableMobile_price_old}>
              {" "}
              $
              {selectedOption.value
                ? `${Number(selectedOption.value) + 10}`
                : 99.99}
            </p>
          </div>
          <Button
            onClick={() => {
              setIsModalUpdateVisible(false);
              setIsModalOrderVisible(true);
            }}
            type="expired"
            text={"Upgrade Now"}
            classNames={styles.root_tableMobile_update}
          />
        </div>
        <div className={styles.root_tableMobile_list}>
          <p className={styles.root_tableMobile_list_title}>
            Premium Package includes:
          </p>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Removes & Detects viruses in real
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Repair Windows Damage
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Operating System Restoration
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Optimize Windows Registry
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Unlimited use for 1 year
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              PC Scan and Assessment
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              24/7 support for 1 year
            </p>
          </div>
          <div className={styles.root_tableMobile_list_item}>
            <img src={done} alt="done" height={20} width={20} />
            <p className={styles.root_tableMobile_list_item_title}>
              Multi-device protection and repair
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetPremiumModal;
